import { FileText } from 'lucide-react';
import { useAuthStore } from '../../../stores/authStore';
import { palette, admin } from '../../../styles/tokens';
import { SettingsSubPage } from '../components/SettingsSubPage';

const STANDARD_FIELDS = [
  { label: 'Full name', required: true },
  { label: 'Phone number', required: true },
  { label: 'Email address', required: false },
  { label: 'Address', required: false },
  { label: 'Notes', required: false },
];

export function ClientFieldsPage() {
  const business = useAuthStore(s => s.business);
  const industry = business?.industry ?? 'general';

  return (
    <SettingsSubPage title="Client fields" description="Custom intake fields per industry">
      <div style={{
        background: palette.white,
        borderRadius: admin.cardRadius,
        border: `1px solid ${admin.border}`,
        overflow: 'hidden',
      }}>
        <div style={{
          padding: '14px 20px',
          borderBottom: `1px solid ${palette.g100}`,
          display: 'flex',
          alignItems: 'center',
          gap: 8,
        }}>
          <FileText size={16} color={palette.g500} strokeWidth={1.8} />
          <span style={{ fontSize: 14, fontWeight: 600, color: palette.g800 }}>
            Standard fields
          </span>
          <span style={{
            fontSize: 11,
            fontWeight: 500,
            color: palette.g400,
            marginLeft: 'auto',
          }}>
            Industry: {industry}
          </span>
        </div>
        <div style={{ padding: '8px 0' }}>
          {STANDARD_FIELDS.map(field => (
            <div key={field.label} style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '10px 20px',
              borderBottom: `1px solid ${palette.g50}`,
            }}>
              <span style={{ fontSize: 13.5, color: palette.g700 }}>{field.label}</span>
              <span style={{
                fontSize: 11,
                fontWeight: 500,
                padding: '2px 8px',
                borderRadius: 6,
                background: field.required ? palette.accentWash : palette.g100,
                color: field.required ? palette.accent : palette.g500,
              }}>
                {field.required ? 'Required' : 'Optional'}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div style={{
        marginTop: 16,
        padding: '12px 16px',
        borderRadius: 8,
        background: palette.g50,
        fontSize: 12.5,
        color: palette.g500,
        lineHeight: 1.5,
      }}>
        Custom client fields are collected when clients book through your booking page or are added manually. Field configuration per industry will be available in a future update.
      </div>
    </SettingsSubPage>
  );
}
